import { i18n, Messages } from '@lingui/core'
import { messages as enMessages } from './locales/en/messages' // TODO: revisit this in the future if we go multi-language

const enum Locales {
  EN = 'en',
}

export const defaultLocale = Locales.EN

// TODO: revisit this in the future if we go multi-language
// index.jsx loads modules that expect i18n to already be activated, so we can't use dynamicActivate
// this needs a refactor/re-thinking if we go multi-language
i18n.loadAndActivate({
  locale: defaultLocale,
  messages: enMessages,
})

export async function dynamicActivate(locale: Locales) {
  const messages = (await import(`./locales/${locale}/messages`)) as Messages
  i18n.load(locale, messages)
  i18n.activate(locale)
}
